import { createRequestString, http } from 'services/base/http';
import { CreateFCMDeviceRequest } from './protos/fcm_device_pb';
import { FCM_TOKEN, PLATFORM, configureFCMToken } from 'services/base/config';

export class FCMService {
  static async update(token?: string): Promise<boolean> {
    if (token != null) {
      configureFCMToken(token);
    }

    if (FCM_TOKEN == null) {
      return false;
    }

    const request = createCreateFCMDeviceRequest(PLATFORM, FCM_TOKEN);
    try {
      await http.post('/fcm-devices/', createRequestString(request));
      return true;
    } catch (e) {
      return false;
    }
  }
}

function createCreateFCMDeviceRequest(platform: string, token: string): CreateFCMDeviceRequest {
  const request = new CreateFCMDeviceRequest();
  request.setType(platform);
  request.setRegistrationId(token);
  return request;
}
